import React from "react";

import i18next from "i18next";

import Dropdown from "components/Dropdown";
import { ReportsIcon } from "svg";

import { Nav } from "./styles";

type Props = {
  isVisible: boolean;
  items: any;
};

const ReportsNavItem = ({ isVisible, items }: Props) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Nav.Item>
      <Dropdown icon={ReportsIcon} title={i18next.t("reports")} items={items} />
    </Nav.Item>
  );
};

export default ReportsNavItem;
